var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "align-items-end" },
    [
      !_vm.loading
        ? _c(
            "b-col",
            { attrs: { md: "12" } },
            [
              _c("h6", { staticClass: "form-title font-sm mb-0" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.tc("global.words.detail", 2)) +
                    ":\n    "
                ),
              ]),
              _vm._v(" "),
              _c("resizable-text-area", {
                staticClass: "w-100",
                staticStyle: { "min-height": "100px" },
                attrs: {
                  id: "notes",
                  value: _vm.note,
                  "maximum-height": 100,
                  "max-length": _vm.maxLength,
                  disabled: _vm.isReadOnly,
                },
                on: { change: _vm.handleChange },
              }),
              _vm._v(" "),
              _c("label", { staticClass: "d-none", attrs: { for: "notes" } }, [
                _vm._v(_vm._s(_vm.$t("global.words.note"))),
              ]),
            ],
            1
          )
        : _c("commissions-notes-loader"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }